<template>
  <ol class="conduct-index-list">
    <li v-for="(item, index) in $t('ethical.list')" :key="`item-${index}`">
      <p>
        <strong>
          <router-link
            :to="{name: 'ethicalPage', params: { ...localeParams }, hash: `#${hashTitle($t(item.title))}`}"
            @click.native="onClickAnchor($event, $t(item.title))"
          >
            {{ $t(item.title) }}
          </router-link>
        </strong>
      </p>
      <ol class="depth-2">
        <li v-for="(child, key) in item.child" :key="`child-${key}`">
          <router-link
            :to="{name: 'ethicalPage', params: { ...localeParams }, hash: `#${hashTitle($t(child.title))}`}"
            @click.native="onClickAnchor($event, $t(child.title))"
          >
            <i>{{ index + 1 }}-{{ key + 1 }}.</i>{{ $t(child.title) }}
          </router-link>
        </li>
      </ol>
    </li>
  </ol>
</template>

<script>
import { hashTitle } from '@/util'
import gtag from '@/mixins/gtag'
import menu from '@/mixins/menu'

export default {
  mixins: [gtag, menu],
  methods: {
    hashTitle,
    onClickAnchor (event, label) {
      this.setGtag({
        action: 'click',
        name: '회사소개_지속가능경영',
        category: '회사소개_지속가능경영',
        label: label,
        page: '회사소개'
      })
    }
  }
}
</script>
